module.exports = __webpack_public_path__ + "static/media/worldwide_customers.155f30b1.png";